import React from 'react'
import {Navigate} from '../react-router-shim'
import {useSelector} from 'react-redux';
import {AUTHENTICATED_ENTRY} from 'configs/AppConfig'

const PublicRoute = ({children}) => {

    const {token} = useSelector(state => state.auth)

    return token ? <Navigate to={AUTHENTICATED_ENTRY}/> : children
}

export default PublicRoute
